// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__4BiY8","range":"MonthRangeSwitch_range__2oEnA","disabled":"MonthRangeSwitch_disabled__22Tgj"};